(() => {
  const sectionSelector = '[data-zenit-product-testimonials]';
  const headerSelector = '.jm-review-widget__header, .jdgm-rev-widg__header';
  const nativeActionSelector = [
    '.jm-write-review-button',
    '.jm-review-widget__write-review',
    '.jdgm-write-rev-link',
    '[class*="write-review"]',
    '[class*="write-a-review"]',
    '[data-testid*="write-review"]'
  ].join(', ');
  const verifiedBadgeSelector = [
    '.jm-review-item .jm-verified-badge',
    '.jdgm-rev .jdgm-rev__buyer-badge'
  ].join(', ');

  const initializedSections = new WeakSet();

  const isVisibleAction = (action) => {
    if (!action || action.hidden || action.disabled || action.getAttribute('aria-hidden') === 'true') return false;
    if (action.closest('[hidden], [aria-hidden="true"]')) return false;

    const styles = window.getComputedStyle(action);
    return styles.display !== 'none' && styles.visibility !== 'hidden';
  };

  const findNativeAction = (content) => {
    const header = content.querySelector(headerSelector);
    if (!header) return null;

    const explicitAction = header.querySelector(nativeActionSelector);
    if (explicitAction) return explicitAction;

    return Array.from(header.querySelectorAll('button, a, [role="button"]')).find((candidate) => {
      return /\b(write|leave)\b[\s\S]*\breview\b/i.test(candidate.textContent || '');
    }) || null;
  };

  const relabelVerifiedBadges = (section) => {
    const label = section.dataset.verifiedPurchaseLabel;
    if (!label) return;

    section.querySelectorAll(verifiedBadgeSelector).forEach((badge) => {
      badge.classList.add('zenit-product-testimonials__verified-badge');
      badge
        .closest('.jdgm-rev__buyer-badge-wrapper')
        ?.classList.add('zenit-product-testimonials__verified-badge-wrapper');

      const reviewItem = badge.closest('.jm-review-item');
      const ratingRow = reviewItem?.querySelector('.jm-star-rating')?.closest('.jm-cluster');
      if (ratingRow && !ratingRow.contains(badge)) ratingRow.append(badge);

      const labelElement = badge.querySelector('.jm-text, .jm-verified-buyer-badge__text');
      if (labelElement) {
        if (labelElement.textContent.trim() !== label) labelElement.textContent = label;
        return;
      }

      const textNode = Array.from(badge.childNodes).find((node) => {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== '';
      });

      if (textNode && textNode.textContent.trim() !== label) textNode.textContent = label;
    });
  };

  const syncSection = (section) => {
    const content = section.querySelector('[data-zenit-review-content]');
    const proxyAction = section.querySelector('[data-zenit-review-action]');
    if (!content || !proxyAction) return;

    section.classList.remove('is-review-bridge-ready');

    const nativeHeader = content.querySelector(headerSelector);
    const nativeAction = findNativeAction(content);
    const canWriteReview = isVisibleAction(nativeAction);

    section._zenitNativeReviewAction = canWriteReview ? nativeAction : null;
    proxyAction.hidden = !canWriteReview;
    section.classList.toggle('is-review-bridge-ready', Boolean(nativeHeader && canWriteReview));
    relabelVerifiedBadges(section);
  };

  const initializeSection = (section) => {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    const content = section.querySelector('[data-zenit-review-content]');
    const proxyAction = section.querySelector('[data-zenit-review-action]');
    if (!content || !proxyAction) return;

    let frame;
    const scheduleSync = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => syncSection(section));
    };

    proxyAction.addEventListener('click', () => {
      const nativeAction = section._zenitNativeReviewAction;
      if (nativeAction && nativeAction.isConnected) nativeAction.click();
    });

    const observer = new MutationObserver(scheduleSync);
    observer.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'disabled', 'hidden']
    });

    syncSection(section);
  };

  const initializeTestimonials = (root = document) => {
    if (root.matches?.(sectionSelector)) initializeSection(root);
    root.querySelectorAll?.(sectionSelector).forEach(initializeSection);
  };

  initializeTestimonials();
  document.addEventListener('shopify:section:load', (event) => initializeTestimonials(event.target));
})();
